module.exports = __webpack_public_path__ + "static/media/teaser-jogging-routen-zh.e07b6f40.jpg";